import React, { useState, useEffect } from "react";
import { Title, Text } from "rizzui/typography";
import { Button, Password } from "rizzui";
import AccountBox from "../../component/accountBox";
import { useForm } from "react-hook-form";
import { passwordValidationPattern } from "./signup";
import { useNavigate } from "react-router";
import { inputClassName, labelClassName } from "../projects/new/first";

export default function NewPassword() {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "New Password";
  }, []);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
  });

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleReset = handleSubmit((data) => {
    console.log(data);
    setIsLoading(true);
    setTimeout(navigate, 3000, "/account/resetsuccessful");
  });

  return (
    <AccountBox>
      <div className="mb-[32px]">
        <Title className="text-[18px] leading-[23.4px] font-[600] text-primary-dark mb-[8px] font-ibmPlexSerif">
          {" "}
          Set a new password{" "}
        </Title>
        <Text className="text-[12px] leading-[18.48px] font-[400] text-secondary-dark font-switzer">
          Enter a new secure password to get access to your Ringconnect account
        </Text>
      </div>

      <div className="text-secondary-dark font-switzer">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleReset();
          }}
          noValidate
        >
          <Password
            label={"New password"}
            variant="text"
            rounded="md"
            className="mb-[24px] text-[12px]"
            inputClassName={inputClassName}
            labelClassName={labelClassName}
            {...register("password", {
              ...passwordValidationPattern,
            })}
            error={errors.password?.message ? errors.password.message : ""}
          />

          <Password
            label={"Confirm password"}
            variant="text"
            rounded="md"
            className="mb-[24px] text-[12px]"
            inputClassName={inputClassName}
            labelClassName={labelClassName}
            {...register("confirmPassword", {
              validate: (value) => {
                const password = watch("password");
                if (password !== value) return "Passwords do not match";
              },
            })}
            error={
              errors.confirmPassword?.message
                ? errors.confirmPassword.message
                : ""
            }
          />

          <Button
            variant="solid"
            className="bg-btn rounded-[4px] text-[12px] font-switzer font-[500] w-full mb-[2px]"
            isLoading={isLoading}
            type="submit"
          >
            Set a new password
          </Button>
        </form>
      </div>
    </AccountBox>
  );
}
